import './index.scss';

import React from 'react';
import { Redirect } from 'react-router-dom';
import Config from '../../config';
import SmileImage from '../../../public/images/smile.svg'
export default class extends React.Component {

  state = {
    facebook: false,
    google: false
  };

  render() {
    return (
      <div className="content-inner-container thank-you">
        <div className="thank-you-inner">
          {/* <i className="fa fa-smile-o" /> */}
          <img src={SmileImage}/>
          <p className="title">
            <strong>Thank you!</strong>
          </p>
          <p>
            We need your help. Would you share your experience on Google?
          </p>
          <div className="sites-holder">
            

            {Config.getGoogleReviewLink() === ''? null :
              (
              <div className="site" onClick={() => this.setState({ google: true })}>
                <img className="desktop" src="/images/google-review.png" />
              </div>
              )
            }

            {Config.getFacebookReviewLink() === ''? null :
              (
                <div className="site" onClick={() => this.setState({ facebook: true })}>
                  <img className="desktop" src="/images/facebook-review-logo.png" />
                </div>
              )
            }

          </div>
        </div>
        {
          this.state.facebook ? (
            <Redirect to={`/${this.props.match.params.group}/${this.props.match.params.key}/thank-you/facebook`} />
          ) : null
        }
        {
          this.state.google ? (
            <Redirect to={`/${this.props.match.params.group}/${this.props.match.params.key}/thank-you/google`} />
          ) : null
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/states/thank-you/index.js